import { render } from "./NewCard.vue?vue&type=template&id=6646ddb2&scoped=true&ts=true"
import script from "./NewCard.vue?vue&type=script&lang=ts"
export * from "./NewCard.vue?vue&type=script&lang=ts"

import "./NewCard.vue?vue&type=style&index=0&id=6646ddb2&lang=scss&scoped=true"

import exportComponent from "/opt/buildhome/repo/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6646ddb2"]])

export default __exports__